export default {
  title01: "وضعیت فعلی هوا",
  title02: "۲۴ ساعت",
  title03: "مشاهده پیش‌بینی ۱۰ روزه هوا",
  title04: "شاخص کیفیت هوا (AQI)",
  title05: "مشاهده تمام اطلاعات",
  title06: "طلوع و غروب خورشید",
  title07: "مرحله ماه",
  title08: "ماه کامل بعدی",
  title09: "ماه نو بعدی",
  title10: "روز",
  title11: "شب",
  title12: "طلوع خورشید",
  title13: "غروب خورشید",
  title14: "طلوع ماه",
  title15: "غروب ماه",
  title16: "منبع",
  title17: "شروع",
  title18: "پایان",
  title19: "استفاده از موقعیت فعلی",
  title20: "جستجوی شهر",
  title21: "احساس واقعی",
  title22: "احساس واقعی (سایه)",
  title23: "اکنون",
  title24: "امروز",
  title25: "یکشنبه",
  title26: "دوشنبه",
  title27: "سه‌شنبه",
  title28: "چهارشنبه",
  title29: "پنج‌شنبه",
  title30: "جمعه",
  title31: "شنبه",
  title32: "در حال بارگذاری...",
  title33: "اکنون",
  title34: "ساعتی",
  title35: "روزانه",
  title36: "خورشید و ماه",
  title37: "کیفیت هوا",
  title38: "تماس: xlf550402@gmail.com",
  title39: "توافقنامه حریم خصوصی",
  title40: "کپی‌رایت © comfortweather.com 2020 - 2026. همه حقوق محفوظ است.",
  title41: "داده‌ها ارائه شده توسط [LOGO]",
  title42: "حداکثر دما",
  title43: "حداقل دما",
  title44: "پذیرش",
  title45:
    "با تشکر از شما برای استفاده از ComfortWeather! برای حفاظت بهتر از حقوق و منافع قانونی خود، لطفاً قبل از استفاده،",
  title46: "«سیاست حفظ حریم خصوصی»",
  title47: "را با دقت مطالعه کنید.",
  title48: "",
  title49: "تماس: xyjph123@gmail.com",
  title50: "کپی‌رایت © 24hweather.com 2020 - 2026. همه حقوق محفوظ است.",
  title51: "با تشکر از استفاده شما از 24hweather! برای حفاظت بهتر از حقوق قانونی خود، لطفاً بخوانید",
  title52: "مکان شما تغییر کرده است. آیا می‌خواهید به‌روزرسانی شود؟",
  title53: "تأیید",
  title54: "لغو",
  title55: "بازگشت",
  title56: "اخبار",
  title57: "در حال به‌روزرسانی هوا...",
  title58: "هوا به‌روز شد",
  title59: "مشاهده همه",
  title60: "کپی‌رایت © mobi321.com 2020 - 2026. همه حقوق محفوظ است.",
  title61: "دیروز",
  title62: "فردا",
  title63: "پیش‌بینی ۱۰ روزه",
  title64: "جزئیات امروز",
  title65: "Rahu Kaal",
  title66: "شاخص‌های سبک زندگی",
  title67: "شاخص‌های سبک زندگی",
  title68: "زمان‌های راهو کال برای ۷ روز آینده",
  title69: "تا",
  title70: "تا",
  title71: "شاخص کیفیت هوا",

  title102: "خشک‌شدن دشوار است",
  title103: "خشک‌شدن کند",
  title104: "به‌خوبی خشک می‌شود",
  title105: "خشک‌شدن سریع",
  title106: "خشک‌شدن بسیار سریع",

  title107: "مناسب نیست",
  title108: "تجربه متوسط",
  title109: "مناسب برای تفریحات آبی",
  title110: "بسیار مناسب",
  title111: "شرایط ایده‌آل",

  title112: "شرایط مساعد برای سلامتی",
  title113: "شرایط خنثی",
  title114: "ریسک کمی بالاتر",
  title115: "ریسک بالا",
  title116: "ریسک بسیار بالا",

  title117: "مناسب نیست",
  title118: "تا حدی مناسب",
  title119: "برای فضای باز مناسب است",
  title120: "بسیار مناسب",
  title121: "شرایط عالی",

  title122: "شرایط بسیار خشک",
  title123: "احتمال خشکی زیاد است",
  title124: "خشکی خفیف",
  title125: "احتمال خشکی کم است",
  title126: "احتمال خشکی بسیار کم است",

  title127: "توصیه نمی‌شود",
  title128: "قابل قبول",
  title129: "روز مناسبی است",
  title130: "شرایط بسیار خوب",
  title131: "شرایط ایده‌آل",
};
